import { useNavigate, useParams } from 'react-router-dom';
import { HeartPulse } from 'lucide-react';
import { usePets } from '../../contexts/PetsContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import { ROUTES } from '../../config/constants';
import HealthRecordForm from './components/HealthRecordForm';

const HealthRecordNewPage = () => {
  const { petId } = useParams();
  const navigate = useNavigate();
  const { pets, status } = usePets();

  if (status === 'loading') {
    return (
      <div className="flex flex-col gap-2">
        <div className="h-12 animate-pulse rounded-2xl bg-slate-100" />
        <div className="h-32 animate-pulse rounded-2xl bg-slate-100" />
      </div>
    );
  }

  const pet = pets.find((p) => p.id === petId);
  if (!pet) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-bold text-slate-900">Mascota no encontrada</h1>
        <Card>
          <p className="text-sm text-slate-600">
            Esta mascota no existe o fue eliminada.
          </p>
          <div className="mt-3">
            <Button variant="secondary" fullWidth onClick={() => navigate(ROUTES.HEALTH)}>
              Volver
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2">
        <HeartPulse className="h-6 w-6 text-rose-700" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Nueva observación</h1>
          <p className="text-sm text-slate-500">Para {pet.name}.</p>
        </div>
      </div>
      <HealthRecordForm petId={petId} />
    </div>
  );
};

export default HealthRecordNewPage;
